import type { FetchResult } from "./opsPaperworkClientBase";
import { opsFetch } from "./opsPaperworkClientBase";
import type { ConsumptionReport } from "@/lib/ops/consumptionReport";
import type { QbBooksEventKind, QbBooksReport } from "@/lib/ops/qbBooksMath";

const BASE = "/api/ops/qb-books";

export type QbBooksEvent = {
  id: string;
  organization_id: string;
  period_start: string;
  period_end: string;
  kind: QbBooksEventKind;
  app_amount_usd: number;
  qb_amount_usd: number;
  variance_usd: number;
  qb_reference: string;
  notes: string;
  document_label: string;
  report_snapshot: Record<string, unknown>;
  status: "posted" | "void";
  created_at: string;
  updated_at: string;
};

export function listOpsQbBooks(periodStart: string, periodEnd: string) {
  const q = new URLSearchParams({ period_start: periodStart, period_end: periodEnd });
  return opsFetch<{ ok: true; report: QbBooksReport; events: QbBooksEvent[]; consumption: ConsumptionReport }>(
    `${BASE}?${q.toString()}`,
    {
      method: "GET",
    }
  );
}

export function createOpsQbBooksEvent(payload: {
  period_start: string;
  period_end: string;
  kind?: QbBooksEventKind;
  qb_amount_usd?: number;
  qb_reference?: string;
  notes?: string;
  document_label?: string;
}) {
  return opsFetch<{ ok: true; event: QbBooksEvent }>(BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function voidOpsQbBooksEvent(id: string) {
  return opsFetch<{ ok: true; event: QbBooksEvent }>(BASE, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, status: "void" }),
  });
}

export type { FetchResult };
